/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardDenaroDTO { 
    /**
     * Budget totale dei bandi in scope
     */
    budget_totale?: number;
    /**
     * Importo impegnato: Σ righe di graduatoria CONFERMATA ammesse-finanziate
     */
    importo_impegnato?: number;
    /**
     * Importo residuo (budget − impegnato, mai negativo)
     */
    importo_residuo?: number;
    voucher_emessi?: number;
    voucher_consegnati?: number;
    voucher_valore_totale?: number;
    voucher_valore_residuo?: number;
}

